import { apiClient } from '@/plugins/axios';

const uploadFile = async (module: string, file: File): Promise<string> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post(`/${module}/file`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data.url;
};

export default {
  uploadFile,
};
